module.exports = __webpack_public_path__ + "static/meet-desktop-fr-8fb4af0c3ff2f1243e81b0ed529dc251.png";